<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li :class="{ active: tabIndex === 0 }" @click="clickTab(0)">
          基本资料
        </li>
        <li :class="{ active: tabIndex === 1 }" @click="clickTab(1)">
          修改密码
        </li>
      </ul>
    </div>
    <div class="member-main-body">
      <div class="account-form" v-show="tabIndex == 0">
        <Form
          ref="information"
          :model="information"
          :label-width="80"
          v-if="tabIndex == 0"
        >
          <FormItem label="用户名">
            <span>{{ loginUser.userName }}</span>
            <!-- <Button
              style="margin-left: 10px; height: 28px; line-height: 26px"
              type="success"
              shape="circle"
              @click="EnidUserNameFn"
              >修改</Button
            > -->
          </FormItem>
          <FormItem label="手机号">
            <span v-if="loginUser.mobile">{{
              this.loginUser.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
            }}</span>
            <span class="color3" v-else> 您还没有绑定手机号 </span>
            <Button
              type="success"
              shape="circle"
              :to="{ name: 'AccountModifyPhone' }"
              v-if="loginUser.mobile"
              style="margin-left: 10px; height: 28px; line-height: 26px"
              >重新绑定</Button
            >
            <Button
              type="success"
              shape="circle"
              :to="{ name: 'AccountBindPhone' }"
              v-else
              style="margin-left: 10px; height: 28px; line-height: 26px"
              >绑 定</Button
            >
          </FormItem>
          <FormItem label="昵称">
            <Input
              v-model="information.nickName"
              size="large"
              placeholder="输入你的昵称"
            />
          </FormItem>

          <FormItem label="性别">
            <RadioGroup v-model="information.sex" size="large">
              <Radio label="男">男</Radio>
              <Radio label="女">女</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="QQ号">
            <Input
              v-model="information.qq"
              type="number"
              size="large"
              placeholder="输入你的QQ号"
            />
          </FormItem>
          <FormItem label="Email">
            <Input
              v-model="information.email"
              type="email"
              size="large"
              placeholder="输入你的Email"
            />
          </FormItem>
          <FormItem label>
            <Button
              type="primary"
              @click="handleSubmit('information')"
              size="large"
              shape="circle"
              long
              >确认提交</Button
            >
          </FormItem>
        </Form>
      </div>
      <div class="account-form" v-show="tabIndex == 1">
        <Form
          ref="formValidate"
          :model="password"
          :label-width="80"
          :rules="ruleValidate"
          v-if="tabIndex == 1"
        >
          <FormItem label="旧密码" prop="oldPassword">
            <Input
              v-model.trim="password.oldPassword"
              password
              size="large"
              type="password"
              placeholder="输入原登录密码"
            />
          </FormItem>
          <FormItem label="新密码" prop="newPassword">
            <Input
              v-model.trim="password.newPassword"
              password
              size="large"
              type="password"
              placeholder="输入新登录密码"
            />
          </FormItem>
          <FormItem label="确认密码" prop="newPassword2">
            <Input
              v-model.trim="password.newPassword2"
              password
              size="large"
              type="password"
              placeholder="请与上面的值输入一致"
            />
          </FormItem>
          <FormItem label>
            <Button
              type="primary"
              @click="handleSubmit('password')"
              size="large"
              shape="circle"
              long
              >确认修改</Button
            >
          </FormItem>
        </Form>
      </div>
    </div>

    <!--修改用户名 -->
    <EnidUserName :visible.sync="visible"></EnidUserName>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";
import { saveLoginUser } from "../../utils/localStorage";
import { checkWeakPassword } from "../../utils/utils";
import EnidUserName from "../../components/common/EnidUserName";
export default {
  mixins: [siteMixin],
  components: { EnidUserName },
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.password.newPassword) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };
    return {
      tabIndex: 0,
      information: {
        qq: "",
        nickName: "",
        email: "",
        sex: "",
      },
      password: {
        oldPassword: "",
        newPassword: "",
        newPassword2: "",
      },

      ruleValidate: {
        oldPassword: [
          {
            required: true,
            message: "请输入原登录密码",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新登录密码",
            trigger: "blur",
          },
        ],
        newPassword2: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur",
          },
          {
            validator: validatePassCheck,
            trigger: "blur",
          },
        ],
      },
      visible: false,
    };
  },
  mounted() {
    this.setMetaData("账户管理");
    this.initData();
  },
  methods: {
    initData() {
      if (this.loginUser.ugid == 6) {
        this.$router.push({ name: "Login" });
        return;
      }
      const info = {
        qq: this.loginUser.qQ,
        nickName: this.loginUser.nickName,
        email: this.loginUser.email,
        sex: this.loginUser.sex,
      };
      this.information = info;
    },
    clickTab(index) {
      if (this.tabIndex == index) return false;
      if (index === 1) {
        this.tabIndex = 0;
        if (this.loginUser.mobile) {
          this.$router.push({ name: "Forget" });
        } else {
          this.$router.push({ name: "AccountBindPhone" });
        }
      }
      this.tabIndex = index;
    },
    handleSubmit(e) {
      switch (e) {
        case "password":
          const data = {
            userId: this.loginUser.userId,
            password: this.$md5(this.password.oldPassword),
            entpassword: this.$md5(this.password.newPassword2),
          };
          console.log(this.$refs["formValidate"]);

          this.$refs["formValidate"].validate(async (valid) => {
            //alert(valid);
            if (valid) {
              const flag = await checkWeakPassword(this.password.newPassword);
              if (!flag) {
                this.$Message.warning({
                  title: "提示",
                  content: "该密码过于简单，请重新设置。",
                });
                return;
              }
              user.updateUserPassword(data).then((res) => {
                //console.log(res);
                if (res.status === 1) {
                  this.password = {
                    oldPassword: "",
                    newPassword: "",
                    newPassword2: "",
                  };
                  this.$Message.success("密码修改成功");
                } else {
                  this.$Message.error(res.message);
                }
              });
            } else {
              this.$Message.error("数据校验失败");
            }
          });
          break;
        case "information":
          const userData = {
            userId: this.loginUser.userId,
            nickname: this.information.nickName,
            sex: this.information.sex,
            QQ: this.information.qq,
            email: this.information.email,
          };
          user.updateUserInfo(userData).then((res) => {
            if (res.status === 1) {
              const userInfo = res.data;
              this.setUserLogin(userInfo);
              saveLoginUser(userInfo);
              this.$Message.success("基本资料修改成功");
            } else {
              this.$Message.error(res.message);
            }
          });
          break;
        default:
          break;
      }
    },
    EnidUserNameFn() {
      this.visible = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";
.account-form {
  width: 400px;
  padding: 30px;
}
</style>
